import { Key } from "@solid-primitives/keyed"
import { useWindowSize } from "@solid-primitives/resize-observer"
import { Accessor, Component, createEffect, createMemo, createSignal, type JSX, type JSXElement } from "solid-js"
import { createMutable } from "solid-js/store"
import type { Nullable } from "vite-node"
import createEngineForUI from "../lib/core/engine/createEngineForUI"
import type { Engine } from "../lib/core/engine/Engine.type"
import createSampleEntity from "../lib/core/entity/createSampleEntity"
import type { EntityTypeMeta } from "../lib/core/EntityTypeMeta"
import type { PlayerId } from "../lib/core/player/PlayerId"
import closeDropDownWhenOtherDropDownOpens from "../lib/event/closeDropDownWhenOtherDropDownOpens"
import EngineContext from "./EngineContext"
import SingleEntityIcon3D from "./MapEditor/SingleEntityIcon3D"

type EntityTypeMetaNull = Nullable<EntityTypeMeta>

interface Props {
  playerId: PlayerId | null,
  value: EntityTypeMetaNull
  onChange: (value: EntityTypeMetaNull) => void
  list: Array<EntityTypeMeta>,
  placeholder: JSXElement,
  hr?: boolean,
}

const SelectEntityTypeMetaDropDownButton: Component<Props> = (props) => {
  const [isDropDownOpen, setIsDropDownOpen] = createSignal<boolean>(false)

  const engine: Engine = createMutable(createEngineForUI())

  function toIcon(etm: EntityTypeMeta, style: JSX.CSSProperties | undefined) {
    const sampleUnit = createSampleEntity(etm.id, props.playerId)
    return <SingleEntityIcon3D entity={sampleUnit} size={40} style={style} />
  }

  const windowSize = useWindowSize()

  // createEffect(() => {
  //   console.log('effect.props.value', deepClone(unwrap(props.value)))
  // })

  const isSelected = (etm: EntityTypeMetaNull) => {
    return etm?.id === props.value?.id
  }

  return <EngineContext.Provider value={engine}>
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle w-100" type="button" aria-expanded="false"
        onClick={() => { setIsDropDownOpen(!isDropDownOpen()) }}
      >
        {!props.value && props.placeholder}
        <Key each={props.list} by="id" children={(etm: Accessor<EntityTypeMeta>) => {
          return <>{toIcon(etm(), {
            display: isSelected(etm()) ? 'inline' : 'none',
            'margin': '0 0.25rem',
          })}</>
        }
        } /> {props.value && (props.value.dname || 'unknown')}
      </button>
      <ul class="dropdown-menu" classList={{ 'dropdown-menu': true, show: isDropDownOpen(), 'w-100': true }}
        ref={(ref) => {
          createEffect(() => {
            // read some signals for triggering
            isDropDownOpen()
            const windowHeight = windowSize.height
            if (ref) {
              const bcr = ref.getBoundingClientRect()
              const maxHeightStr = `${parseInt(((windowHeight * 0.9) - bcr.top) as unknown as string)}px`
              ref.style.setProperty('max-height', maxHeightStr)
              ref.style.setProperty('overflow-y', 'scroll')
            }
          })

          closeDropDownWhenOtherDropDownOpens(ref, isDropDownOpen, setIsDropDownOpen)
        }}>
        <Key each={props.list} by="id">
          {(etm: Accessor<EntityTypeMeta>, index: Accessor<number>) => {
            const showHR = createMemo(() => {
              if (props.hr) {
                const prevEtm = props.list[index() - 1]
                if (prevEtm) {
                  return prevEtm.group_id !== etm().group_id
                }
              }
            })
            return <>
              {showHR() && <hr />}
              <li>
                <button class="dropdown-item" type="button"
                  onClick={() => {
                    props.onChange(etm())
                    setIsDropDownOpen(false)
                  }}
                >
                  {toIcon(etm(), {
                    'margin': '0 0.25rem',
                  })} {etm().dname}
                </button>
              </li>
            </>
          }}
        </Key>
      </ul>
    </div>
  </EngineContext.Provider>
}

export default SelectEntityTypeMetaDropDownButton

